module.exports = __webpack_public_path__ + "img/ry_13.84571682.jpg";